import React from 'react'

import Checkbox from '@SonarCX/pages/Settings/Controls/Checkbox'
import Info from '@SonarCX/components/atoms/Info'

import { useTaskFilters } from '@SonarCX/providers/TaskFiltersProvider'
import { track } from '@SonarCX/lib/mixpanel'
import useStyles from './styles'

const FavoritesCheckbox: React.FC = () => {
  const { onlyFavorites, setOnlyFavorites } = useTaskFilters()

  const classes = useStyles()

  const handleToggle = React.useCallback(
    val => {
      track('ALL_TASKS_TOGGLE_FAVORITES_FILTER')
      setOnlyFavorites(val)
    },
    [setOnlyFavorites]
  )

  return (
    <>
      <Checkbox
        checked={onlyFavorites}
        onCheck={handleToggle}
        className={classes.root}
      >
        Only favorites
      </Checkbox>
      <Info
        text={'Favorites filter cannot be saved yet.'}
        className={classes.info}
      />
    </>
  )
}

export default FavoritesCheckbox
